import {API} from 'aws-amplify';
import axios from "axios";

const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === 'true';
const baseURL = process.env.REACT_APP_APIURL;

export async function resetPasswordApi(queryObj: any) {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/user/resetPassword`, queryObj);
  }
  return API.post('Backend', "/user/resetPassword", {body: queryObj});
}
export async function forgotPasswordApi(email: any) {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/user/forgotPassword`, email);
  }
  return API.post('Backend', "/user/forgotPassword", {body: email});
}
export async function resendVerifyEmailApi(email: any) {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/user/resendVerify`, email);
  }
  return API.post('Backend', "/user/resendVerify", {body: email});
}
export async function verifyApi(token: any) {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/user/verify`, token);
  }
  return API.post('Backend', "/user/verify", {body: token});
}
export async function loginUserApi(user: any) {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/user/login`, user);
  }
  return API.post('Backend', "/user/login", {body: user});
}
export const checkClient = async ({email}:{email:string}) => {
  try {
    const response = await axios.post(`${baseURL}/user/checkClient`, {
      email,
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};
